<script>
	import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Layout from "@/router/layouts/main";

	import { todoComputed, todoMethods } from "@/state/helpers";

	/**
	 * Starter component
	 */
	export default {
		page: {
			title: "Data Driver",
			meta: [{ name: "description", content: appConfig.description }],
		},
		components: {
			Layout,
			PageHeader,
		},
		data() {
			return {
				tableData: [
					{
						id: 1,
						name: "Lucinda Stickley",
						position: "Manager",
						current_fleet: "Truck",
						NIK: "123456789",
						phone_no: "089898989",
						place_of_recruitment: "Surabaya",
						this_month_score: "90",
						joined_date: "21 Jan 2021",
						status: "Active",
						inactive_date: "-",
					},
					{
						id: 2,
						name: "Lucinda Stickley",
						position: "Manager",
						current_fleet: "Truck",
						NIK: "123456789",
						phone_no: "089898989",
						place_of_recruitment: "Surabaya",
						this_month_score: "90",
						joined_date: "21 Jan 2021",
						status: "Active",
						inactive_date: "-",
					},
				],
				totalRows: 1,
				todoTotalRows: 1,
				currentPage: 1,
				todocurrentPage: 1,
				perPage: 10,
				todoperPage: 10,
				pageOptions: [10, 25, 50, 100],
				todoOptions: [10, 50, 100, 150, 200],
				filter: null,
				todoFilter: null,
				filterOn: [],
				todofilterOn: [],
				sortBy: "name",
				sortDesc: false,
				// fields: [
					
				// ],
			};
		},
		computed: {
			...todoComputed,
			/**
			 * Total no. of records
			 */
			rows() {
				return this.tableData.length;
			},

			title(){
				return this.$t("global.driver")
			},

			items() {
				return [
					{
						text: this.$t("menuitems.masterData.text"),
					},
					{
						text: this.$t("global.driver"),
						active: true,
					},
				]
			},

			fields() {
				return [
					{
						key: "name",
						label: this.$t("master.list.driver.name"),
						sortable: true,
					},
					{
						key: "position",
						label: this.$t("master.list.driver.position"),
						sortable: true,
					},
					{
						key: "current_fleet",
						label: this.$t("master.list.driver.currentFleet"),
						sortable: true,
					},
					{
						key: "NIK",
						label: this.$t("master.list.driver.nik"),
						sortable: true,
					},
					{
						key: "phone_no",
						label: this.$t("master.list.driver.phone"),
						sortable: true,
					},
					{
						key: "place_of_recruitment",
						label: this.$t("master.list.driver.placeOfRecruitment"),
						sortable: true,
					},
					{
						key: "this_month_score",
						label: this.$t("master.list.driver.monthScore"),
						sortable: true,
					},
					{
						key: "joined_date",
						label: this.$t("master.list.driver.joinedDate"),
						sortable: true,
					},
					{
						key: "status",
						label: this.$t("master.list.driver.status"),
						sortable: true,
					},
					{
						key: "inactive_date",
						label: this.$t("master.list.driver.inActiveDate"),
						sortable: true,
					},
				]
			},

			/**
			 * Todo list of records
			 */
			todoList() {
				return this.todos.length;
			},
		},
		mounted() {
			this.fetchTodos();
			// Set the initial number of items
			this.totalRows = this.tableData.length;

			this.todoTotalRows = this.todos.length;
			// axios
			//   .get("http://dummy.restapiexample.com/api/v1/employees", {
			//     headers: {
			//       "Content-type": "application/json;charset=utf-8",
			//     },
			//   })
			//   .then((res) => {
			//     return res;
			//   });
		},
		methods: {
			...todoMethods,
			/**
			 * Search the table data with search input
			 */
			onFiltered(filteredItems) {
				// Trigger pagination to update the number of buttons/pages due to filtering
				this.totalRows = filteredItems.length;
				this.currentPage = 1;
			},

			onRowClicked(item){
				this.$router.push({ name: 'Master Driver Update', params: {id: item.id} })
			},

			todoFiltered(filteredItems) {
				// Trigger pagination to update the number of buttons/pages due to filtering
				this.todoTotalRows = filteredItems.length;
				this.todocurrentPage = 1;
			},

			handleInput(value, data) {
				this.editableDataItems[data.index][data.field.key] = value;
			},
		},
	};
</script>
<template>
	<Layout>
		<PageHeader :title="title" :items="items" />

		<div class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-body">
						<div class="row mb-2">
							<div class="col-sm-12 col-md-6">
								<b-button
									variant="primary"
									size="sm"
									@click="$router.push({ name: 'Master Driver Create' })"
								>
									<i class="bx bx-plus"></i> {{ $t('global.create') }}
								</b-button>
							</div>
							<!-- Search -->
							<div class="col-sm-12 col-md-6">
								<div
									id="tickets-table_filter"
									class="dataTables_filter text-md-end"
								>
									<label class="d-inline-flex align-items-center">
										<b-form-input
											v-model="filter"
											type="search"
											:placeholder="this.$t('global.search')"
											class="form-control form-control-sm ms-2"
										></b-form-input>
									</label>
								</div>
							</div>
							<!-- End search -->
						</div>
						<!-- Table -->
						<div class="table-responsive mb-0">
							<b-table
								class="datatables"
								show-empty
								:empty-text="$t('global.emptyTable')"
								:items="tableData"
								:fields="fields"
								responsive="sm"
								:per-page="perPage"
								:current-page="currentPage"
								:sort-by.sync="sortBy"
								:sort-desc.sync="sortDesc"
								:filter="filter"
								:filter-included-fields="filterOn"
								@filtered="onFiltered"
								@row-clicked="onRowClicked"
							></b-table>
						</div>
						<div class="row">
							<div class="col-sm-12 col-md-6">
								<div id="tickets-table_length" class="dataTables_length">
									<label class="d-inline-flex align-items-center">
										{{ $t('global.show') }}
										<b-form-select
											class="form-select form-select-sm"
											v-model="perPage"
											size="sm"
											:options="pageOptions"
										></b-form-select>
									</label>
								</div>
							</div>
							<div class="col-sm-12 col-md-6">
								<div
									class="dataTables_paginate paging_simple_numbers float-end"
								>
									<ul class="pagination pagination-rounded mb-0">
										<!-- pagination -->
										<b-pagination
											v-model="currentPage"
											:total-rows="rows"
											:per-page="perPage"
										></b-pagination>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>